import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { teamsSettingsRoute } from '@townsquare/routes/teams-settings-view';

import { teamsSettingsResource } from './resources/teams-settings';

const TeamsSettingsLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "TeamsSettingsView" */ './components/SettingsView'),
	loading: () => null,
	delay: 0,
});

teamsSettingsRoute.component = TeamsSettingsLoadable;
teamsSettingsRoute.resources = [teamsSettingsResource, onboardingResource];
export const teamsSettingsRouterRoute: GlobalHomePageRoute = teamsSettingsRoute;
